var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBodega(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C20.9241 8.94415 20.1321 5.95017 18.6895 3.25828C18.6037 3.09822 18.4359 3 18.2543 3H5.74566C5.56406 3 5.39628 3.09822 5.3105 3.25828C3.86791 5.95017 3.07594 8.94415 3 12C3.07594 15.0559 3.86791 18.0498 5.3105 20.7417C5.39628 20.9018 5.56406 21 5.74566 21H18.2543C18.4359 21 18.6037 20.9018 18.6895 20.7417C20.1321 18.0498 20.9241 15.0559 21 12Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C15.9781 8.95372 15.439 5.92472 14.3979 3H9.60209C8.56104 5.92472 8.02185 8.95372 8 12C8.02185 15.0463 8.56104 18.0753 9.60209 21H14.3979C15.439 18.0753 15.9781 15.0463 16 12Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7H20",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17H20",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodega);
export default __webpack_public_path__ + "static/media/Bodega.12aec686abf18db704e42d13cb7f2681.svg";
export { ForwardRef as ReactComponent };